/**
 * Cliente API de accesos citofonía y wifi (Sprint 18 P5 B2).
 *
 * El vecino solicita un slot de citofonía (1-4) o wifi para un residente
 * de su casa; la comisión valida o rechaza. El vecino también puede dar
 * de baja un acceso (libera el slot / cupo). La validación física de la
 * centralita y el sistema wifi externo la opera la comisión/tesorero —
 * el portal solo registra la intención (espejo del HW).
 */
import { apiFetch } from './client';
import type {
  AccesoCitofoniaRead,
  AccesoWifiRead,
  SolicitarCitofoniaPayload,
  SolicitarWifiPayload,
} from './types';

// === Citofonía ===

export function listarCitofoniaDeLote(
  loteId: string,
): Promise<AccesoCitofoniaRead[]> {
  return apiFetch<AccesoCitofoniaRead[]>(
    `/lotes/${loteId}/accesos-citofonia`,
  );
}

export function solicitarCitofonia(
  data: SolicitarCitofoniaPayload,
): Promise<AccesoCitofoniaRead> {
  return apiFetch<AccesoCitofoniaRead>('/me/accesos-citofonia', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export function darDeBajaCitofonia(
  accesoId: string,
): Promise<AccesoCitofoniaRead> {
  return apiFetch<AccesoCitofoniaRead>(
    `/me/accesos-citofonia/${accesoId}/baja`,
    { method: 'POST' },
  );
}

// === Wifi ===

export function listarWifiDeLote(loteId: string): Promise<AccesoWifiRead[]> {
  return apiFetch<AccesoWifiRead[]>(`/lotes/${loteId}/accesos-wifi`);
}

export function solicitarWifi(
  data: SolicitarWifiPayload,
): Promise<AccesoWifiRead> {
  return apiFetch<AccesoWifiRead>('/me/accesos-wifi', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export function darDeBajaWifi(accesoId: string): Promise<AccesoWifiRead> {
  return apiFetch<AccesoWifiRead>(`/me/accesos-wifi/${accesoId}/baja`, {
    method: 'POST',
  });
}

// === Validación de la Comisión (Sprint 19 A2) ===

export function validarCitofonia(
  accesoId: string,
): Promise<AccesoCitofoniaRead> {
  return apiFetch<AccesoCitofoniaRead>(
    `/accesos-citofonia/${accesoId}/validar`,
    { method: 'POST' },
  );
}

export function rechazarCitofonia(
  accesoId: string,
  motivoRechazo: string,
): Promise<AccesoCitofoniaRead> {
  return apiFetch<AccesoCitofoniaRead>(
    `/accesos-citofonia/${accesoId}/rechazar`,
    { method: 'POST', body: JSON.stringify({ motivo_rechazo: motivoRechazo }) },
  );
}

export function validarWifi(accesoId: string): Promise<AccesoWifiRead> {
  return apiFetch<AccesoWifiRead>(`/accesos-wifi/${accesoId}/validar`, {
    method: 'POST',
  });
}

export function rechazarWifi(
  accesoId: string,
  motivoRechazo: string,
): Promise<AccesoWifiRead> {
  return apiFetch<AccesoWifiRead>(`/accesos-wifi/${accesoId}/rechazar`, {
    method: 'POST',
    body: JSON.stringify({ motivo_rechazo: motivoRechazo }),
  });
}
